interface Lookup<V> {
  [key: string]: V
}

export const CONDITION_STATUS_COLORS: Lookup<string> = {
  active: '#4cb782',
  controlled: '#f2c94c',
  resolved: '#bec2c8',
}

export const ALLERGY_STATUS_COLORS: Lookup<string> = {
  active: '#eb5757',
  inactive: '#bec2c8',
}

export const ALLERGY_TYPE_LABELS: Lookup<string> = {
  allergy: 'Allergy',
  intolerance: 'Intolerance',
}

export const SEVERITY_BADGE_COLORS: Lookup<'red' | 'orange' | 'green'> = {
  severe: 'red',
  moderate: 'orange',
  mild: 'green',
}
